import { IndexedDBService } from '../../../services/indexeddb/store-persist/indexeddb.service';

type Reducer<S, A> = (state: S, actions: A) => S;

// tslint:disable-next-line:no-string-literal
window['__REDUCERS__'] = new Map();
declare const __REDUCERS__: Map<string, Record<string, any>>;

interface IPersistReducerOptions<S, A> {
    initialState: S;
    reducer: Reducer<S, A>;
    name: string;
}

/**
 * Reducer persitente em IndexedDB
 *
 * @param reducerName
 * @param initialState
 * @param reducer
 * @returns
 */
export const persistReducer = <S, A>({ initialState, reducer, name: reducerName}: IPersistReducerOptions<S, A>) => {
    return function reducerPersitant(state: S, action: A) {

        const isInitialState = !state;

        if (isInitialState && __REDUCERS__.has(reducerName)) {
            // tslint:disable-next-line:no-console
            console.info('Assumir valor inicial de', reducerName, 'persistido DB');
            initialState = __REDUCERS__.get(reducerName) as S;
        }

        const newState = reducer(isInitialState ? initialState : state, action);

        // Persistir mudanças de estado no database
        if (!isInitialState) {

            const { hubStore } = IndexedDBService.dbs;
            const table = hubStore.table('reducers');

            /**
             * Realiza leitura do estado do reducer na base do indexeddb
             */
            const readState = async () => {
                return await table
                    .where('name')
                    .equals(reducerName)
                    .first();
            };

            /**
             * Persiste o estado do reducer na table da base indexeddb
             *
             * @param newState
             * @param isNew
             * @returns
             */
            const persistState = (isNew: boolean) => {
                return table[isNew ? 'put' : 'add']({ name: reducerName, state: newState })
                    // tslint:disable-next-line:no-console
                    .catch(console.error);
            };

            // TODO: O persist ocorre de forma assícrona ao retorno do novo estado
            // Atenção: em casos de persit seguido de redirect, adicione um (debounceTime) antes de fazer o redirect
            hubStore.transaction('rw', table, async () => {
                const parsitedState = await readState();
                await persistState(!!parsitedState);
            });

        }

        return newState;

    };

};

/**
 * Ler dados do indexeddb
 * Deve ser chamando antes de carregar qualquer módulo
 * Adicione essa chamada no arquivo main-aot do projeto que deseja utiliza-lo
 */
export const syncReducersDatabaseOnBootstrap = async () => {

    const { hubStore } = IndexedDBService.dbs;
    const table = hubStore.table('reducers');

    await hubStore.transaction('rw', table, async () => {
        const reducers = await table.toArray();
        reducers.forEach(({ name, state }) => __REDUCERS__.set(name, state));
        // tslint:disable-next-line:no-console
        console.info(`Sincronizados ${__REDUCERS__.size} reducers do indexeddb`);
    });

};
